import { useLocation } from 'react-router-dom';
import {getMemberTermsAndAgreeInfoList, getMemberTermsMstList} from "../../api/termsApi";
import { useEffect, useState } from 'react';
import {TermsAgreeTypes, TermsTypes} from "../../types/terms.types";

import {formatKoreaDate} from "../../utils/format";
import DOMPurify from 'dompurify';

export default function TermsDetail() {
    const location = useLocation();
    const { termsGroupCode } = location.state || {};
    const [termsList, setTermsList] = useState<TermsTypes[]>([]);
    const [selectedTermsGroup, setSelectedTermsGroup] = useState<string>(termsGroupCode || '');
    const [termsAgreeList, setTermsAgreeList] = useState<TermsAgreeTypes[]>([]);
    const [selectedTermsCode, setSelectedTermsCode] = useState<string>('');
    const [isLoading, setIsLoading] = useState(true);

    const getTermsMstList = async () => {
        try {
            setIsLoading(true);
            const result = await getMemberTermsMstList();
            if (result.data.code == "00") {
                setTermsList(result.data.data);
                const initialGroup = termsGroupCode || result.data.data[0]?.termsGroupCode;
                if (initialGroup) {
                    setSelectedTermsGroup(initialGroup);
                    await getTermsList(initialGroup);
                }
            }
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    };


    const getTermsList = async (termsGroup: string) => {
        try {
            setIsLoading(true);
            const result = await getMemberTermsAndAgreeInfoList(termsGroup);
            if (result.data.code == "00") {
                setTermsAgreeList(result.data.data);
                if (result.data.data.length > 0) {
                    setSelectedTermsCode(result.data.data[0].termsCode);
                }
            }
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getTermsMstList();
    }, []);

    const termsGroupChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.target.value;
        setSelectedTermsGroup(value);
        getTermsList(value);
    }

    const termsCodeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedTermsCode(e.target.value);
    };

    const selectedTerms = termsAgreeList.find(item => item.termsCode === selectedTermsCode);

    return (
        <>

            {!isLoading && selectedTerms && (
                <div className="bottom-btn">
                    <div className="text-box">
                        <p className="bottom-guide terms">
                            {selectedTerms.agreeDate ? (selectedTerms.termsYn ? "동의" : "미동의") : "동의"} 일자 : &nbsp;
                            <strong>{formatKoreaDate(selectedTerms.agreeDate || "") || "-"}</strong>
                        </p>
                    </div>
                </div>
            )}

            <main className="container">
                <section className="bg-white">
                    <div className="dropSearch">
                        <select
                            value={selectedTermsGroup}
                            onChange={termsGroupChange}
                        >
                            {termsList.map((item: TermsTypes, index: number) => {
                                return (
                                    <option key={index} value={item.termsGroupCode}>{item.termsName}</option>
                                )
                            })}
                        </select>
                        <select
                            value={selectedTermsCode}
                            onChange={termsCodeChange}
                        >
                            {termsAgreeList.map((item: TermsAgreeTypes, index: number) => {
                                return (
                                    <option key={index} value={item.termsCode}>{formatKoreaDate(item.startDate)}</option>
                                )
                            })}
                        </select>
                    </div>
                    <div className="boardDetail terms">
                        <div className="inner-box">
                            <div className="terms-wrap" dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(selectedTerms?.contents || '')
                            }}>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    )
};